import { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";

/**
 * High-quality crisp SVG Barcode Renderer using JsBarcode
 */
export default function BarcodeRenderer({
  value = "",
  format = "CODE128",
  width = 1.5,
  height = 36,
  displayValue = true,
  fontSize = 11,
  font = "monospace",
  textMargin = 2,
  margin = 0,
  lineColor = "#000000",
  background = "transparent",
  className = "",
  altText = "",
}) {
  const svgRef = useRef(null);

  useEffect(() => {
    if (!svgRef.current || !value || !String(value).trim()) return;

    const cleanValue = String(value).trim();

    try {
      JsBarcode(svgRef.current, cleanValue, {
        format: format || "CODE128",
        width,
        height,
        displayValue,
        fontSize,
        font,
        textMargin,
        margin,
        lineColor,
        background,
        text: altText || cleanValue,
      });
    } catch (err) {
      console.warn("JsBarcode error with format", format, "falling back to CODE128:", err);
      try {
        JsBarcode(svgRef.current, cleanValue, {
          format: "CODE128",
          width,
          height,
          displayValue,
          fontSize,
          font,
          textMargin,
          margin,
          lineColor,
          background,
          text: altText || cleanValue,
        });
      } catch (fallbackErr) {
        console.error("Barcode generation failed completely:", fallbackErr);
      }
    }
  }, [value, format, width, height, displayValue, fontSize, font, textMargin, margin, lineColor, background, altText]);

  if (!value || !String(value).trim()) {
    return (
      <div className={`flex items-center justify-center border border-dashed border-muted-foreground/40 text-[10px] text-muted-foreground py-2 ${className}`}>
        No Barcode Value
      </div>
    );
  }

  return (
    <svg
      ref={svgRef}
      className={`mx-auto max-w-full block ${className}`}
      style={{ shapeRendering: "crispEdges" }}
    />
  );
}
